import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";

const HONEYBOOK_URL = "https://app.hellobonsai.com/s/n-santiago-media/strategycall";

const CTASection = () => {
  return (
    <section className="section-padding section-navy relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-primary/5 via-transparent to-primary/5" />

      <motion.div
        initial={{ opacity: 0, y: 40, scale: 0.97 }}
        whileInView={{ opacity: 1, y: 0, scale: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        className="relative z-10 max-w-3xl mx-auto text-center"
      >
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="font-heading text-3xl md:text-4xl lg:text-5xl mb-6 text-white"
        >
          Find out where your clinic is <span className="gold-gradient-text">losing patients.</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.25 }}
          className="text-white/60 text-lg mb-10 max-w-xl mx-auto"
        >
          A Dental Growth Audit reviews your visibility, trust, website, reviews, content, and conversion systems to uncover missed opportunities.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.35 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <a href={HONEYBOOK_URL} target="_blank" rel="noopener noreferrer">
            <Button variant="hero" size="lg" className="px-12 py-7 text-sm">
              Get My Dental Growth Audit
            </Button>
          </a>
        </motion.div>
        <p className="text-white/40 text-xs mt-6">
          No obligation. A clear review of what's working, what's not, and where the next patients come from.
        </p>
      </motion.div>
    </section>
  );
};

export default CTASection;
